import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { logoPreferencesState } from '../Recoil/RecoilState';

const LOGO_PREFERENCES_KEY = 'app-logo-preferences';

export const useLogoPersistence = () => {
  const [logoPreferences, setLogoPreferences] = useRecoilState(logoPreferencesState);

  // Load logo preferences from localStorage on mount
  useEffect(() => {
    const savedPreferences = localStorage.getItem(LOGO_PREFERENCES_KEY);
    if (savedPreferences) {
      try {
        const parsed = JSON.parse(savedPreferences);
        setLogoPreferences(parsed);
      } catch (error) {
        console.warn('Failed to parse logo preferences from localStorage:', error);
      }
    }
  }, [setLogoPreferences]);

  // Save logo preferences to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem(LOGO_PREFERENCES_KEY, JSON.stringify(logoPreferences));
  }, [logoPreferences]);

  return [logoPreferences, setLogoPreferences];
}; 